// extracted by mini-css-extract-plugin
export var text = "_2x-0";